import { filterClasses } from "@swivl-mono/helpers";
import { ReactNode } from "react";

export interface PopoverMenuItem {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  danger?: boolean;
  disabled?: boolean;
}

export interface PopoverMenuDivider {
  divider: true;
}

export type PopoverMenuEntry = PopoverMenuItem | PopoverMenuDivider;

export const isPopoverMenuDivider = (entry: PopoverMenuEntry): entry is PopoverMenuDivider => "divider" in entry && entry.divider === true;

export interface PopoverMenuProps {
  entries: PopoverMenuEntry[];
}

export function PopoverMenu({ entries }: PopoverMenuProps): React.ReactElement {
  return (
    <ul className="flex w-full flex-col gap-1" role="menu">
      {entries.map((entry, index) =>
        isPopoverMenuDivider(entry) ? (
          <li key={`divider-${index}`} className="my-1 px-2" role="separator">
            <div className="h-px bg-grey-300" />
          </li>
        ) : (
          <li key={entry.label} role="none">
            <button
              type="button"
              role="menuitem"
              disabled={entry.disabled}
              onClick={(e) => {
                e.stopPropagation();
                entry.onClick();
              }}
              className={filterClasses(
                "body-sm flex w-full items-center gap-2 rounded-sm p-2 text-left",
                entry.danger ? "text-red-500" : "text-grey-900",
                // Cursor is EITHER/OR: with both classes present the pointer one
                // won in the generated CSS, so disabled rows showed a pointer.
                entry.disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer hover:bg-grey-50"
              )}
            >
              {entry.icon && <span className="flex size-4 shrink-0 items-center justify-center">{entry.icon}</span>}
              <span className="min-w-0 flex-1 truncate">{entry.label}</span>
            </button>
          </li>
        )
      )}
    </ul>
  );
}
